export default "__VITE_ASSET__606f9dd9__"